"use client"

import { getFixedT } from "@/languages/i18n"
import { Form } from "antd"
import { ReactNode } from "react"

interface FormFieldProps {
    name: string
    label: ReactNode
    required?: boolean
    rules?: any[]
    type?: "text" | "email" | "textarea"
    rows?: number
    className?: string
    locale?: string
}

export const FormField: React.FC<FormFieldProps> = ({
    name,
    label,
    required = false,
    rules = [],
    type = "text",
    rows = 4,
    className = "",
    locale,
}) => {
    const t = getFixedT(locale)
    const inputClassName = `w-full px-3 h-12 border border-[#ced4da] focus:outline-none focus:ring-1 focus:ring-[#37b24d] rounded text-base ${className}`

    const formRules = required
        ? [{ required: true, message: t("Cannot be empty") }, ...rules]
        : rules

    const renderInput = () => {
        if (type === "textarea") {
            return (
                <textarea
                    rows={rows}
                    className={`${inputClassName} resize-none`}
                />
            )
        }

        return (
            <input
                type={type}
                className={inputClassName}
            />
        )
    }

    return (
        <Form.Item name={name} label={label} rules={formRules}>
            {renderInput()}
        </Form.Item>
    )
}

